module.exports = __webpack_public_path__ + "img/approved.e462c17a.svg";